import { useContext, useState } from 'react'
import { CreateTeacherContext} from '../provider/_context'
import { useCreateProductAction } from '../provider/_action'
import { sendRequestAuth } from '../../../../../api/api'
import config from '../../../../../config'
import { useParams } from 'react-router-dom'
import { removeAcent } from 'common/fieldText/_functions'
import useAlert from '../../../../../hook/useAlert'

export const useCreateProductTable = () => {
  const { pageState, pageDispatch } = useContext(CreateTeacherContext)

  const { teacherId } = useParams()
  const {showAlert} = useAlert()

  const { productTab } = pageState
  const { filter } = productTab

  const searchActiveValue = filter.search.activeValue
  const searchValue = filter.search.value

  const handleSearchChange = value => {
    pageDispatch({
      type: useCreateProductAction.FILTER_SEARCH_UPDATE,
      payload: value,
    })
  }

  // ===== ===== ===== ===== =====
  // STATUS FILTER
  // ===== ===== ===== ===== =====
  const statusValue = filter?.status?.value
  const statusActiveValue = filter?.status?.activeValue

  const handleStatusChange = value => {
    pageDispatch({
      type: useCreateProductAction.FILTER_STATUS_VALUE_UPDATE,
      payload: value
    })
  }
// ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  // ===== ===== ===== ===== =====
  // CATEGORY FILTER
  // ===== ===== ===== ===== =====
  const categoryList = filter?.category?.list
  const categoryListOrigin = filter?.category?.listOrigin
  const categoryValue = filter?.category?.value
  const categoryActiveValue = filter?.category?.activeValue

  const handleCategoryChange = value => {
    pageDispatch({
      type: useCreateProductAction.FILTER_CATEGORY_VALUE_UPDATE,
      payload: value
    })
  }

  const handleCategoryKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const categoryListData = categoryListOrigin.filter(item => {
      const formatNameItem = item?.title
        ? removeAcent(item?.title.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue?.trim())) return true
      return false
    })
    pageDispatch({
      type: useCreateProductAction.FILTER_CATEGORY_LIST_UPDATE,
      payload: categoryListData
    })
  }
  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====


  const queries = {
    category_id: categoryValue?.id || '',
    status: statusValue?.value || '',
    keyword: searchValue || '',
    per_page: productTab?.table?.pagination?.amount || 20,
    start: (productTab?.table?.pagination?.active * productTab?.table?.pagination?.amount) || 0,
  }

  const applyOtherFilter = async () => {
    const qs = {
      ...queries,
      per_page: productTab?.table?.pagination?.amount,
      start: 0
    }
    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }
    fetchProductByFilter(queryString)
  }


  const handleAmountChange = async n => {
    const qs = { ...queries, per_page: n, start: 0 }
    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }
    fetchProductByFilter(queryString)

  }

  const handlePageChange = async page => {
    const amount = productTab?.table?.pagination?.amount || 20
    const qs = {
      ...queries,
      per_page: productTab?.table?.pagination?.amount,
      start: page * amount
    }
    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }
    fetchProductByFilter(queryString)
  }

  const fetchProductByFilter = async (qs) => {
    pageDispatch({
      type: useCreateProductAction.TABLE_LOADING_DISPLAY,
      payload: true
    })
    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/principal/teacher/products/${teacherId}${qs}`)
    ])
    if (response[0]?.data?.success) {
      pageDispatch({
        type: useCreateProductAction.TABLE_LOADING_DISPLAY,
        payload: false
      })
      const tearchers = response[0]?.data
      pageDispatch({
        type: useCreateProductAction.TABLE_UPDATE_DISPLAY_LIST,
        payload: {
          list: tearchers?.data,
          listDefault: tearchers?.data,
          loading: false
        }
      })
      pageDispatch({
        type: useCreateProductAction.TABLE_UPDATE_PAGINATION,
        payload: {
          active: Math.ceil(tearchers?.meta?.start / tearchers?.meta?.per_page),
          amount: tearchers?.meta?.per_page,
          total: Math.ceil(tearchers?.meta?.total / tearchers?.meta?.per_page),
          totalItems: tearchers?.meta?.total,
        }
      })

      pageDispatch({
        type: useCreateProductAction.TABLE_SELECTED_LIST_UPDATE,
        payload: {selected: {list: []}},
      })
    }
  }

  const listProduct = productTab.table.display.list
  const removeProductFromPrincipal = async (id) => {
    const response = await sendRequestAuth('post', `${config.API}/principal/teacher/delete-products/${teacherId}`,
      {
        'product_ids': id
      }
    )
    if(!!response?.data?.success){
      showAlert({
        type: 'success',
        content: 'Xóa sản phẩm thành công'
      })
      // Xóa sản phẩm thành công
      const newProducts = listProduct.filter(item => item.id !== id)
      pageDispatch({
        type: useCreateProductAction.TABLE_UPDATE_DISPLAY_LIST,
        payload: {
          list: newProducts,
          listOrigin: newProducts
        }
      })
    }else{
      showAlert({
        type: 'danger',
        content: response?.data?.message || 'Đã xóa sản phẩm thất bại'
      })
    }
  }


  // handel select product Table

  const {table} = productTab

  const displayList = table.display.list
  const selectedList = table.selected.list

  // CHECKBOX
  const shouldActiveCheckbox = selectedList.length > 0

  const isActive =
    displayList.length <= 0
      ? false
      : selectedList.length < displayList.length
      ? false
      : !!!displayList.find(
        item => !!!selectedList.find(find => find?.id === item?.id),
      )

  const handleCheckboxChange = () => {
    let newSelectedList = []
    if (isActive) {
      newSelectedList = selectedList.filter(
        item => !!!displayList.find(find => find?.id === item?.id),
      )
    } else {
      let addingList = []
      displayList.forEach(item => {
        if (!!!selectedList.find(find => find?.id === item?.id))
          addingList = [...addingList, item]
      })
      newSelectedList = [...selectedList, ...addingList]
    }
    pageDispatch({
      type: useCreateProductAction.TABLE_SELECTED_LIST_UPDATE,
      payload: {selected: {list: newSelectedList}},
    })
  }


  // SELECTED ACTION DROPDOWN
  const [shouldOpenSelectedActionMenu, setShouldOpenSelectedActionMenu] =
    useState(false)


  const handleDeleteProduct = async () => {
    //dispatch show
    const response = await sendRequestAuth('post', `${config.API}/principal/teacher/delete-products/${teacherId}`,
      {
        'product_ids': selectedList.map(item => item.id).join(',')
      }
    )
    return response
    // if(!!response?.data?.success){
    //   showAlert({
    //     type: 'success',
    //     content: 'Xóa sản phẩm thành công'
    //   })
    //   // Xóa sản phẩm thành công
    //   const newProducts = listProduct.filter(item => item.id !== id)
    //   pageDispatch({
    //     type: useCreateProductAction.TABLE_UPDATE_DISPLAY_LIST,
    //     payload: {
    //       list: newProducts,
    //       listOrigin: newProducts
    //     }
    //   })
    // }else{
    //   showAlert({
    //     type: 'danger',
    //     content: response?.data?.message || 'Đã xóa sản phẩm thất bại'
    //   })
    // }
  }

  return {
    table: pageState.productTab.table,
    queries,
    statusFilter: {
      value: statusValue,
      statusValue: statusActiveValue,
      activeValue: statusActiveValue,
      onChange: handleStatusChange,
    },
    search: {
      value: searchValue,
      activeValue: searchActiveValue,
      onChange: handleSearchChange,
    },
    categoryFilter: {
      value: categoryValue,
      activeValue: categoryActiveValue,
      list: categoryList,
      onChange: handleCategoryChange,
      onKeywordChange: handleCategoryKeywordChange
    },
    pagination: {
      onAmountChange: handleAmountChange,
      onPageChange: handlePageChange,
    },

    methods: {
      applyOtherFilter,
      removeProductFromPrincipal
    },

    checkbox: {
      checked: shouldActiveCheckbox,
      onClick: handleCheckboxChange,
    },
    selected: {
      actionMenu: {
        open: shouldOpenSelectedActionMenu,
        onToggle: setShouldOpenSelectedActionMenu,
        actions: [
          () => handleDeleteProduct(),
        ],
      },
      list: selectedList,
    },
  }
}